import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import 'photoswipe/dist/photoswipe.css';

const initPhotoSwipeLightbox = () => {
    const lightbox = new PhotoSwipeLightbox({
        gallery: '#project-gallery',
        children: 'a',
        closeTitle: 'Sulge',
        zoomTitle: 'Zoom',
        zoom: false,
        bgOpacity: 0.9,
        pswpModule: () => import('photoswipe'),
        /*caption: (element, data) => {
          return element.querySelector('a').getAttribute('data-pswp-caption');
        }*/
        /*getThumbBoundsFn: (index) => {
          const thumbnail = document.querySelectorAll('#project-gallery a')[index].querySelector('img');
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          const rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }*/
    });
    lightbox.init();
};

export { initPhotoSwipeLightbox };